import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-33d814a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container-fluid"
}

import { useRoute, useRouter } from "vue-router";
import Images from '@/components/image/Images.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PageBanner',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_unref(route).meta.imgBanner != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(Images, {
            preview: false,
            src: _unref(route).meta.imgBanner
          }, null, 8, ["src"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})